<template>
    <div class="gridArticles">
        <h2 v-if="showTitle" class="baron headerText">News</h2>
        <div class="grid" v-if="articles && articles.length > 0">
            <ItemArticle v-for="article in articles" :key="article" :article="article" />
        </div>
        <div class="noresults" v-else-if="articles && articles.length == 0">
            No articles matching your search.
        </div>
        <NPagination v-if="pageCount && pageCount > 1" v-model:page="page" :page-count="pageCount" :show-quick-jump-dropdown="false" :page-slot="5" size="large" @update-page="pageUpdate" />
    </div>
</template>

<script lang="ts" setup>
import { NPagination } from 'naive-ui';

interface Props {
    articles: any[];
    page?: number;
    showTitle?: boolean;
    meta?: { total_count?: number, filter_count?: number };
}

const props = withDefaults(defineProps<Props>(), {
    showTitle: true
})
const emit = defineEmits(['update-page'])
const page = ref(props.page || 1)

const pageCount = computed(() => {
    if (props.meta && props.meta.filter_count) return Math.ceil(props.meta.filter_count / 8)
    else return null
})

const pageUpdate = (page: number) => {
    emit('update-page', page)
}
</script>

<style lang="scss" scoped>
.gridArticles {
    margin: 0 var(--size-margin-page);

    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-double);

    h2 {
        border-top: var(--size-thickness) solid var(--color-primary);
        font-weight: normal;
        color: var(--color-primary);
        padding-top: var(--size-margin-page);
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: var(--size-gutter-double) var(--size-margin-page);
    }

    .noresults {
        min-height: 500px;
    }
}

@media screen and (max-width: 1200px) {
    .gridArticles {
        .grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);
        }
    }
}

@media screen and (max-width: 768px) {
    .gridArticles {
        .grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);
        }
    }
}

@media screen and (max-width: 600px) {
    .gridArticles {
        .grid {
            display: grid;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);
        }
    }
}
</style>